import { Tag } from 'antd';
import type { TagProps } from 'antd';
import React from 'react';

import classes from './FieldTypeChips.module.css';

export const BooleanChip: React.FC<TagProps> = (props) => <Tag {...props} className={classes.booleanChip} />;

export const CurrencyChip: React.FC<TagProps> = (props) => <Tag {...props} className={classes.currencyChip} />;

export const DateChip: React.FC<TagProps> = (props) => <Tag {...props} className={classes.dateChip} />;

export const DateTimeChip: React.FC<TagProps> = (props) => <Tag {...props} className={classes.dateTimeChip} />;

export const ImageChip: React.FC<TagProps> = (props) => <Tag {...props} className={classes.imageChip} />;

export const IntegerChip: React.FC<TagProps> = (props) => <Tag {...props} className={classes.integerChip} />;

export const LinkChip: React.FC<TagProps> = (props) => <Tag {...props} className={classes.linkChip} />;

export const NumberChip: React.FC<TagProps> = (props) => <Tag {...props} className={classes.numberChip} />;

export const FileChip: React.FC<TagProps> = (props) => <Tag {...props} className={classes.fileChip} />;

export const DraftChip: React.FC<TagProps> = (props) => <Tag {...props} className={classes.draftChip} />;
